import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import { useInfiniteScroll } from "../../../../utils/pagination";

import SearchBox from "../../../../components/formElements/searchbox/SearchBox";

import PatientList from "./PatientList";

const MyPatients = ({
  patients,
  searchPatient,
  total_pages,
  emptyPatientList,
  getDoctorPatientList,

}) => {
  const [page, setPage] = useState(1);
  
  const loader = useRef(null);

  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });
  
  useEffect(() => {
    if (page > 0 && page <= total_pages && !patients?.searchedPatientsValue) {
      getDoctorPatientList(page,"");
    }
    else if (
     
      patients?.searchedPatientsValue &&
      patients?.searchedPatientsValue.length >= 3 &&
      page > 0 &&
      page <= total_pages

    ) {
      

      getDoctorPatientList(page,patients?.searchedPatientsValue);
    }
    // eslint-disable-next-line
  }, [page,patients?.searchedPatientsValue]);
    // eslint-disable-next-line
  
  
  useEffect(() => {
    emptyPatientList("myPatients");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          <SearchBox
            value={patients?.searchedPatientsValue || ""}
            onChange={val =>{
              searchPatient(val)
              setPage(1)
            }}
          />
        </div>
      </div>
      <PatientList
        patients={patients?.myPatients}
      />
      <div ref={loader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  patients: dashboard?.patients,
  total_pages: dashboard?.patients?.totalPatientPages,
});

const mapDispatchToProps = dispatch => ({
  getDoctorPatientList: (page,searchData) => dispatch(actions.getDoctorPatientList(page,searchData)),
  searchPatient: searchData => dispatch(actions.searchPatient(searchData)),
  emptyPatientList: currentTab =>
    dispatch(actions.emptyPatientList(currentTab)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(MyPatients)
);
